export const WeightenedOKRId = '6ad87b41-2e7c-49ad-9919-f997c4b03807'
export const LinkedOKRId = "f826a2a0-595f-4ced-9ba9-d0c88c162ac6"

export const ManagerProgressId = 'e9edd03a-a32e-43de-b191-36da221c03f1'
export const PersonelProgressId = '16854e2f-3fb2-4ded-aca3-3720319fec39'

export const CoHrId = 'b3dc00a0-810a-4b64-a44e-f98dda9e56d0'

export const TeamOKRId = '93c61149-7817-4320-bdfd-7bc24da25cbd'


//KPI
export const KPIGoalEntryPersonKindPersonel = "b2f0199d-00e8-425f-a278-ef47e671828c"
export const KPIGoalEntryPersonKindManager = "29435750-4fec-41ea-a4e2-7d3ebc4a32be"
export const KPIResultEntryPersonKindPersonel = "177f2b42-f7b5-4fbf-8bd3-6de9ed9990f5"
export const KPIResultEntryPersonKindManager = "efdf3429-b516-40cc-81c5-f32526629e6d"